// ETCswap token list - includes ETC mainnet (61) and Mordor testnet (63) assets
export const DEFAULT_TOKEN_LIST_URL = 'https://raw.githubusercontent.com/etcswap/tokens/main/ethereum-classic/all.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [
  DEFAULT_TOKEN_LIST_URL
]
